import { render, staticRenderFns } from "./PayoutTransDetails.vue?vue&type=template&id=2e42252a&scoped=true"
import script from "./PayoutTransDetails.vue?vue&type=script&lang=js"
export * from "./PayoutTransDetails.vue?vue&type=script&lang=js"
import style0 from "./PayoutTransDetails.vue?vue&type=style&index=0&id=2e42252a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e42252a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e42252a')) {
      api.createRecord('2e42252a', component.options)
    } else {
      api.reload('2e42252a', component.options)
    }
    module.hot.accept("./PayoutTransDetails.vue?vue&type=template&id=2e42252a&scoped=true", function () {
      api.rerender('2e42252a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ezpay/data/components/PayoutTransDetails.vue"
export default component.exports